resourcePaths = '{"rootPath":"","assetsPath":""}';/*
    ContentfulParser

    Parser to flatten and strip out unnecessary details in response from Contentful.
    Automatically resolves linked objects in the response.
*/
var ContentfulParser = {
  /*
      Exposes sys attributes in main object as _[attribute]. Attributes not listed here
      are copied to the __meta attribute in the flattened object.

      NOTE: id must always be set to true
  */
  _EXPOSE_KEYS: {id: true, type: true, linkType: true, revision: true, contentType: true, updatedAt: true},

  _verbose: 2,

  /*
      Flatten Contentful response.

      Arguments:
          response [JSON object] (required):
              The response from Contentful that should be flattened.
          verbose [Integer] (optional):
              A verbose flattened object or not, specified levels 0 to 2. Defaults to 2.

      Returns:
          [JSON object]
              The flattened response.
  */
  parseToFlatten: function (response, verbose) {
    verbose = parseInt(verbose);
    if (!isNaN(verbose) && verbose >= 0 && verbose <= 2) this._verbose = verbose;
    var result = this._flattenContentfulResponse(response);
    if (this._verbose < 2) {
      result = this._filterNotVerbose(result, this._verbose);
    }
    return result;
  },

  /*
      Recursive function to flatten Contentful response.
  */
  _flattenContentfulResponse: function (obj, resultObj, refObj) {
    var root = false;
    if (resultObj == null) {
      root = true;
      resultObj = {};
      refObj = {
        linksObj: {}
      };
    }

    if (obj instanceof Array) {
      resultObj = [];
      for (var i = 0; i < obj.length; i++) {
        resultObj[i] = {};
        resultObj[i] = this._flattenContentfulResponse(obj[i], resultObj[i], refObj);
      }
    } else if (typeof(obj) == 'string') {
      resultObj = obj;
    } else {
      for (var key in obj) {
        var processed = false;

        // Sys object
        if (key === 'sys') {
          processed = true;
          var meta = this._processSysObject(obj.sys, refObj);
          var metaLen = Object.keys(meta.metaObj).length;
          if (metaLen > 0) resultObj.__meta = meta.metaObj;
          if (this.__isReference(meta)) {
            refObj.linksObj[meta.exposedObj._id] = {};
            if (metaLen > 0) refObj.linksObj[meta.exposedObj._id].__meta = meta.metaObj;
          }
          for (var key2 in meta.exposedObj) {
            resultObj[key2] = meta.exposedObj[key2];
            if (this.__isReference(meta)) {
              refObj.linksObj[meta.exposedObj._id][key2] = meta.exposedObj[key2];
            }
          }
        }

        // Includes object
        if (key === 'includes') {
          processed = true;
          var includes = obj.includes;
          for (var key2 in includes) {
            if (includes.hasOwnProperty(key2)) {
              var includeGroup = includes[key2];
              for (var i = 0; i < includeGroup.length; i++) {
                refObj.linksObj[includeGroup[i].sys.id] = {};
                refObj.linksObj[includeGroup[i].sys.id] = this._flattenContentfulResponse(
                  includeGroup[i],
                  refObj.linksObj[includeGroup[i].sys.id],
                  refObj
                );
              }
            }
          }
        }

        // Fields object
        if (key === 'fields' && Object.keys(obj.fields).length > 0) {
          processed = true;
          var fields = obj.fields;
          for (var key2 in fields) {
            if (fields.hasOwnProperty(key2)) {
              if (typeof fields[key2] !== 'object') {
                resultObj[key2] = fields[key2];
                if (resultObj._id) {
                  refObj.linksObj[resultObj._id][key2] = fields[key2];
                }
              } else {
                resultObj[key2] = {};
                resultObj[key2] = this._flattenContentfulResponse(
                  fields[key2],
                  resultObj[key2],
                  refObj
                );
                if (resultObj._id) {
                  refObj.linksObj[resultObj._id][key2] = resultObj[key2];
                }
              }
            }
          }
        }

        // Items object
        if (key === 'items') {
          processed = true;
          if (obj.items.length > 0) {
            resultObj.items = [];
            for (var i = 0; i < obj.items.length; i++) {
              resultObj.items[i] = {};
              resultObj.items[i] = this._flattenContentfulResponse(
                obj.items[i],
                resultObj.items[i],
                refObj
              );
            }
          }
        }

        // Other parameters
        if (!processed) {
          if (obj.sys) {
            this.__addToMetaData(resultObj, key, obj[key]);
          } else {
            resultObj[key] = obj[key];
          }
        }
      }
    }

    // Recursion complete
    if (root) {
      resultObj = this._resolveLinks(resultObj, refObj);
    }

    return resultObj;
  },

  _processSysObject: function (obj, refObj) {
    var resObj = {
      metaObj: {},
      exposedObj: {}
    };
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (this._EXPOSE_KEYS[key]) {
          resObj.exposedObj['_' + key] = obj[key];
        } else {
          if (typeof obj[key] === 'object') {
            resObj.metaObj[key] = {};
            resObj.metaObj[key] = this._flattenContentfulResponse(
              obj[key],
              resObj.metaObj[key],
              refObj
            );
          } else {
            resObj.metaObj[key] = obj[key];
          }
        }
      }
    }

    return resObj;
  },

  _resolveLinks: function (resultObj, refObj) {
    // If it's a link
    if (resultObj._type != null && resultObj._type === 'Link' && resultObj._id != null) {
      // Get link type
      var linkType = '';
      if (resultObj.__meta && resultObj.__meta.linkType) linkType = resultObj.__meta.linkType;
      else if (resultObj._linkType) linkType = resultObj._linkType;

      // If linkType is not a Space or ContentType or Environment
      if (
        linkType != '' &&
        linkType != 'Space' &&
        linkType != 'ContentType' &&
        linkType != 'Environment'
      ) {
        var id = resultObj._id;
        if (refObj.linksObj[id] != null) {
          resultObj = refObj.linksObj[id];
          // Resolve any links in resolved link
          resultObj = this._resolveLinks(resultObj, refObj);
        } else {
          console.warn('ContentfulParser.js Could not resolve link ' + id);
        }
      }
    } else {
      for (var key in resultObj) {
        if (resultObj.hasOwnProperty(key)) {
          if (resultObj[key] != null && typeof resultObj[key] === 'object') {
            resultObj[key] = this._resolveLinks(resultObj[key], refObj);
          }
        }
      }
    }

    return resultObj;
  },

  _filterNotVerbose: function (resultObj, verboseLevel) {
    // Remove meta
    if (verboseLevel < 2) {
      if (resultObj.__meta) {
        delete resultObj.__meta;
      }
    }

    for (var key in resultObj) {
      if (resultObj[key] != null) {
        if (verboseLevel === 0) {
          if (key.indexOf('_') === 0) {
            delete resultObj[key];
          } else if (typeof resultObj[key] === 'object') {
            resultObj[key] = this._filterNotVerbose(resultObj[key], verboseLevel);
          }
        } else if (typeof resultObj[key] === 'object') {
          resultObj[key] = this._filterNotVerbose(resultObj[key], verboseLevel);
        }
      }
    }
    return resultObj;
  },

  __addToMetaData: function (obj, key, value) {
    if (obj.__meta == null) obj.__meta = {};
    obj.__meta[key] = value;
  },

  __isReference: function (metaObject) {
    if (this.__getValueFromMetaObj(metaObject, 'id') == null) return false;

    if (this.__getValueFromMetaObj(metaObject, 'type') === 'Link') {
      return false;
    }
    return true;
  },

  __getValueFromMetaObj: function (metaObj, key) {
    if (metaObj.metaObj[key] != null) {
      return metaObj.metaObj[key];
    } else if (metaObj.exposedObj['_' + key] != null) {
      return metaObj.exposedObj['_' + key];
    }
    return null;
  }
};
